module.exports = __webpack_public_path__ + "img/pic-sound-on.1a63daa.webp";